export const UPDATE_PASSWORD_WORK = "UPDATE_PASSWORD_WORK";
export const SET_TIME_INACTIVE = "SET_TIME_INACTIVE";
